module.exports = __webpack_public_path__ + "static/media/bellabyte-camisa-uniforme-personalizado-768x591.feef7795.jpg";